<template>
  <div ref="canvas" class="canvas" id="bim-preview-background">

   <v-btn
   @click="$emit('toggleViewerMinimize')"
   style="position: absolute; margin: 5px;"
   :title="viewerMinimized ? 'Maximize Viewer' : 'Minimize Viewer'">
    <TIcon v-if="!viewerMinimized" name="scale-down"/>
    <TIcon v-else name="scale-up"/>
    <!-- {{ viewerMinimized ? 'Maximize' : 'Minimize' }} -->
    </v-btn>
  </div>
</template>

<script>
// import * as THREE from 'three';
import {
// AmbientLight,
// DirectionalLight,
// PerspectiveCamera,
// Scene,
// WebGLRenderer,

// AxesHelper,
// Color,
// GridHelper,
// // plan test
// SphereGeometry,
// DoubleSide,
// Mesh,
// Vector2,
// Shape,
// ExtrudeGeometry,
// Raycaster,
// BufferGeometry,
// Group,

// MeshLambertMaterial,

// BufferAttribute,
//fpv test
} from "three";
import { IfcInitializeMixin } from '@/mixins/IfcInitializePreview.mixin.js';
// import { mapState, mapGetters, mapActions } from 'vuex';
import { mapActions } from 'vuex';
import TIcon from '@/components/Taktify/TIcon.component.vue';


export default {
  data: () => ({
    scene: null,
    camera: null,
    renderer: null,
    cube: null,
    size: '',
  }),
  components: {
        TIcon,
      },
  props: ['viewerMinimized'],

  computed: {
    taktarea() {
      return this.$store.state.Ultra.taktareas[this.$route.params.taktarea_id]
    }

  },
  mixins: [
    IfcInitializeMixin,
    ],
  mounted() {
    this.initializeScene();
    window.addEventListener('resize', this.onWindowResize);

    const projectID = this.$route.params.project_id;
    let project_object = this.getUObject({type: 'projects', id: projectID});
    console.log(`Project: ${project_object}`);

    //Copy from ReworkProjectstructure:
    let promises = [
      // request ta elements and save it to tas in ultra store

      this.requestUObject({
        url: [
          // { projects: this.project_id },
          { projects: projectID },
          { taktareaselements: '' }
        ],
      }),
      //request projectstucture
      this.requestUObject({
        url: [
          // { projects: this.project_id },
          { projects: projectID },
          { projectstructure: '' }
        ],
      }),
      //request project with steps
      this.requestUObject({
        url: [
          // { projects: this.project_id },
          { projects: projectID },
          { showWithSteps: '' }
        ],
      }),

      // request project elements and steps
      // this.requestProjectElements(this.project_id),
      this.requestProjectElements(projectID),
      // this.requestProjectSteps(this.project_id),
      this.requestProjectSteps(projectID),

    ];
    Promise.allSettled(promises).then(() => {
      this.loading_structure = false;
      // this.createTree('spatial');
      // this.createTree('process');

      // setTimeout(() => {
      //   this.sceneLoadModels(this.taktarea.elements);
      // }, 3000);
      this.sceneLoadModels(this.taktarea.elements);
      // console.log(this.taktarea);
    });


  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    ...mapActions('Ultra', [
      'requestUObject',
      'updateUObject',
      'updateUObjectRelations',
    ]),
    ...mapActions('UltraDev', [
      'updateUDObject',
    ]),
    ...mapActions('ProjectStructure', [
      'planDetectRoomsCall',
      'requestProjectElements',
      'requestProjectSteps',
      'initializeTreeSettings',
      'updateSetting',
      'initializeProcessParents',
    ]),

    onWindowResize() {
      const canvasWidth = this.$refs.canvas.offsetWidth;
      const canvasHeight = this.$refs.canvas.offsetHeight;
      const aspectRatio = canvasWidth / canvasHeight;

      this.camera.aspect = aspectRatio;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(canvasWidth, canvasHeight);
    },
  },
}
</script>

<style>
#bim-preview-background {
    /* height: 67%; */
    aspect-ratio: 16 / 9;
    max-width: 100%;
  }

canvas {
  height: 100%;
  width: 100%;
  /* border: solid red 1px; */
}
</style>